import { render, staticRenderFns } from "./InformationDetails.vue?vue&type=template&id=0f5ad76e"
import script from "./InformationDetails.vue?vue&type=script&lang=js"
export * from "./InformationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports